( function($) {
    $(document).ready(function() {
        window.callAPI = function (path, data, success, reject) {
            var API_URL = path;

            return jQuery.ajax({
                'url': API_URL,
                'data': data,
                'dataType': 'json',
                'success': success,
                'error': reject
            });
        };
        
        var formConfirmed = false;

        window.recaptchaNewsletterCallback = function( token ) {
            var form = $('#form-newsletter form');
            var infoEl = form.find('[newsletter-info]');
            var data = {};
            data = form.serializeObject();
            data.token = token;
            data.action = infoEl.find('[name=action]').val();
            data.code = infoEl.find('[name=security-code]').val();

            callAPI( data.url, data, function(response){

                if( response.success){
                    form.hide();
                    $('#form-newsletter .message-submit.success').fadeIn('slow');
                }
                else {
                    form.hide();
                    if( typeof response.data !== 'undefined' && typeof response.data[0].code !== 'undefined' && response.data[0].code === -8){
                        $('#form-newsletter .message-submit.exists').fadeIn('slow');
                    }
                    else {
                        
                        $('#form-newsletter .message-submit.fail').fadeIn('slow');
                    }
                }
                
    
            }, function(response){
                form.hide();
                $('#form-newsletter .message-submit.fail').fadeIn('slow');
            } );
        };

        $('#form-newsletter form').on('submit', function(e) {
            if( !formConfirmed){
                e.preventDefault();
                var newsletterCaptcha = grecaptcha.render('submitInput', {
                    'sitekey' : $('[newsletter-captcha-key]').val(),
                    'callback' : recaptchaNewsletterCallback
                });

                grecaptcha.reset(newsletterCaptcha);
                grecaptcha.execute(newsletterCaptcha);

            }
            
        });


        $.fn.serializeObject = function(){
            var o = {};
            var a = this.serializeArray();
            $.each(a, function() {
                if (o[this.name] !== undefined) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };

    } )
} ( jQuery ) );